import { timestampDate } from '@bufbuild/protobuf/wkt';
import { Client } from '@connectrpc/connect';

import { ShareLinkService } from './espb/share_link_service_pb';
import { Email, ShareLinkId } from './types';

export default class ShareLinkServiceClient {
  constructor(private readonly espbClient: Client<typeof ShareLinkService>) {}

  async preview(shareLinkId: ShareLinkId): Promise<{
    encryptedPayload: Uint8Array;
    organizationName?: string;
    senderEmail: Email;
    expiresAt?: Date;
  }> {
    const resp = await this.espbClient.preview({ shareLinkId });
    return {
      encryptedPayload: resp.encryptedPayload,
      organizationName: resp.organizationName || undefined,
      senderEmail: resp.senderEmail,
      expiresAt: resp.expiresAt ? timestampDate(resp.expiresAt) : undefined,
    };
  }

  async show(shareLinkId: ShareLinkId): Promise<{
    encryptedPayload: Uint8Array;
    encryptedProtectedSecret: Uint8Array;
    organizationName?: string;
    senderEmail: Email;
  }> {
    const resp = await this.espbClient.show({ shareLinkId });
    return {
      encryptedPayload: resp.encryptedPayload,
      encryptedProtectedSecret: resp.encryptedProtectedSecret,
      organizationName: resp.organizationName || undefined,
      senderEmail: resp.senderEmail,
    };
  }
}
